module.exports = __webpack_public_path__ + "static/account.8d08838c.jpg";